export const getTransparentBackground = (background?: Background) => {
    if (background === 'desert') return '#AD9993';
    if (background === 'country') return '#71cc9f';
    if (background === 'city') return '#d4d4d4';
    if (background === 'lake') return '#97a8fa';
    if (background === 'space') return '#8389ba';

    return '#fff';
};
